<template>
  <span>
    <router-link :title="$t('stocks')"
               v-b-tooltip.hover
               class="tdclickable data-table-action"
               :to="{ name: 'WarehousesStocks', query: params }">
      <BoxSvg/><span class="action-button-mob-title">{{ $t('stocks') }}</span>
    </router-link>
    <span v-if="object.deleted_at">
      <a class="data-table-action"
        v-b-tooltip.hover
        @click="restore"
        :title="$t('restore')">
        <RestoreSvg/><span class="action-button-mob-title">{{ $t('restore') }}</span>
      </a>
    </span>
  </span>
</template>

<script setup>
import BoxSvg from '@/assets/svg-vue/warehouse/box.svg'
import RestoreSvg from "@/assets/svg-vue/accounting/back.svg.vue"
import {computed} from "vue"
import {EloquentService} from "@/services/api/eloquent.api.service"
import {useStore} from "vuex"

const props = defineProps({
  object: Object
})

const store = useStore()

const params = computed(() => {
  return {
    filters: JSON.stringify({
      warehouse_id: {
        id: 'warehouse_id',
        condition: props.object.id,
        type: 'equals'
      }
    })
  }
})

const restore = async () => {
  await EloquentService.restore('warehouse', props.object.id)
  store.commit('incrementDataTableCounter')
}
</script>
